import { render } from "./ListeBanquePage.vue?vue&type=template&id=ca078fb6&ts=true"
import script from "./ListeBanquePage.vue?vue&type=script&lang=ts"
export * from "./ListeBanquePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__